import { AlertCircle, RefreshCw, WifiOff } from 'lucide-react';
import { Button } from '../ui/button';

export function ErrorState({ 
  title = 'Error al cargar datos',
  message = 'No se pudieron obtener los datos. Por favor, inténtalo de nuevo.',
  onRetry,
  fromCache = false
}) {
  return (
    <div 
      className="flex flex-col items-center justify-center py-12 px-4 text-center gap-4"
      role="alert"
    >
      <div className="rounded-full bg-destructive/10 p-4">
        <AlertCircle 
          className="h-8 w-8 text-destructive" 
          aria-hidden="true"
        />
      </div>
      <div>
        <h3 className="font-semibold text-lg">{title}</h3>
        <p className="text-muted-foreground text-sm mt-1">{message}</p>
      </div>
      {onRetry && (
        <Button 
          onClick={onRetry}
          variant="outline"
          className="gap-2"
          data-testid="retry-button"
        >
          <RefreshCw size={16} aria-hidden="true" />
          Reintentar
        </Button>
      )}
    </div>
  );
}

export function CacheWarning() {
  return (
    <div 
      className="flex items-center gap-2 bg-warning/10 text-warning-foreground border border-warning/30 rounded-lg px-4 py-2 text-sm"
      role="status"
    >
      <WifiOff size={16} className="shrink-0 text-warning" aria-hidden="true" />
      <span>Mostrando datos guardados. Sin conexión al servidor.</span>
    </div>
  );
}

export function EmptyState({ 
  title = 'Sin datos',
  message = 'No hay datos disponibles para mostrar.',
  icon: Icon = AlertCircle
}) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center gap-4">
      <div className="rounded-full bg-muted p-4">
        <Icon className="h-8 w-8 text-muted-foreground" aria-hidden="true" />
      </div>
      <div>
        <h3 className="font-semibold">{title}</h3>
        <p className="text-muted-foreground text-sm mt-1">{message}</p>
      </div>
    </div>
  );
}

export default ErrorState;
